/** Clamps a numeric value to the 0–100 percentage range. */
export const clampPercentage = (value: number): number => Math.min(100, Math.max(0, value));

/** Rounds then clamps a value to 0–100 (for fit scores displayed as whole percents). */
export const clampRoundedPercentage = (value: number): number => clampPercentage(Math.round(value));
